import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface APIKeyRowProps {
  apiKey: {
    created_at: string;
    key_hint: string;
  };
}

function APIKeyRow({apiKey}: APIKeyRowProps): JSX.Element {
  return (
    <>
      <td style={{minWidth: 250}}>{`• • • • • • • • ${apiKey.key_hint}`}</td>
      <td />
      <td />
      <td>{apiKey.created_at}</td>
      <td>
        <span className="delete pull-right glyphicon glyphicon-trash" />
      </td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<APIKeyRowProps>(APIKeyRow);
